const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};

//header promohide
document.addEventListener("DOMContentLoaded", () => {
  let promobar = document.getElementById("promo-bar");
  let promoBarHeight, promoHidden;
  var lastScrollTop = 0;
  if ($(window).width() <= 768 && promobar) {
    $(window).scroll(function (_event) {
      var st = $(this).scrollTop();
      if (promobar.clientHeight > 44 || promobar.clientHeight == 0) {
        if (promoHidden != true) {
          promoBarHeight = promobar.clientHeight;
        }
        if (st > lastScrollTop && st > promoBarHeight * 2) {
          promobar.style.display = "none";
          promoBarHeight = promoBarHeight;
          promoHidden = true;
        } else {
          if (st + $(window).height() < $(document).height()) {
            promobar.style.display = "block";
            promoHidden = false;
          }
        }
      }
    });
  }
});

const fadeSwapImage = debounce((el, src, timing) => {
  if (el.src.includes(src)) return;

  let image = new Image();
  image.src = src;

  image.onload = function () {
    let imageElement = el.cloneNode();
    imageElement.src = image.src;
    el.parentElement?.insertBefore(imageElement, el);

    el.animate([{ opacity: 0 }], {
      duration: timing,
      fill: "forwards",
      easing: "ease-in-out",
    }).onfinish = () => {
      el.parentElement?.querySelectorAll("img").forEach((image) => {
        if (image !== imageElement) image.remove();
      });
    };
  };
}, 250);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-card").forEach((productCard) => {
    productCard.querySelectorAll(".color-selector label").forEach((colorSelector) => {
      ["click", "mouseenter"].forEach((event) => {
        colorSelector.addEventListener(event, () => {
          let imageElement = productCard.querySelector(".product-card-image");
          let colorImage = colorSelector.dataset.productImage;
          colorSelector.parentElement.querySelector("input").checked = true;
          fadeSwapImage(imageElement, colorImage, 200);
        });
      });
    });
    productCard.querySelectorAll(".button-selector label").forEach((varSelector) => {
      varSelector.addEventListener("click", function () {
        let name = this.getAttribute("name");
        let value = this.getAttribute("value");
        this.parentElement.querySelector("input").checked = true;

        productCard.querySelector(`.${name}-name`).innerHTML = value;
      });
    });
  });
});
